import {getAllJobCount} from '../../service/JobService';
import {buildSummaryCountMap} from './schedulerUtils';

export default async function loadSummaryCountMap(jobs) {
    const jobIds = [...new Set(jobs.map(job => job.cos_job_id).filter(Boolean))];
    if (!jobIds.length) return {};
    try {
        const response = await getAllJobCount(jobIds);
        if (response.status !== 200) return {};
        return buildSummaryCountMap(await response.json());
    } catch (error) {
        console.log('Unable to load job summary counts', error);
        return {};
    }
}
